import { StyledErrorDisplayContainer } from './styles'
import { ForbiddenIcon } from '../../../app-v2/assets/icons/Forbidden'
import { Text } from '../typography'
import { colors } from '../../../app-v2/design-systems'
import React from 'react'

type ErrorDisplayProps = { error: string }
export const ErrorDisplay = (props: ErrorDisplayProps) => {
    return props.error ? (
        <StyledErrorDisplayContainer>
            <ForbiddenIcon size={24} />
            <Text color={colors.white}>{props.error}</Text>
        </StyledErrorDisplayContainer>
    ) : null
}
